import React, { useEffect } from 'react';
import { post } from '../../../util/api';

const checkPassword = () => {
  if (typeof window !== 'undefined') {
    let password;
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('earlybird') === 'true') {
      window.localStorage.setItem('earlyBirdPass', 'true');
      password = 'true';
    }

    password = window.localStorage.getItem('earlyBirdPass');
    if (!password) window.location.pathname = '/coming-soon';
  }
};

const ComingSoonChecker = () => {
  useEffect(() => {
    checkPassword();
  }, []);
  return <div></div>;
};

export default ComingSoonChecker;
